import React, { useState, useEffect, useContext } from 'react';
import { FooterContainer } from '../styledComponents/Footer.styled';
import { useTranslation } from 'react-i18next';
import { LanguageSelectorStyled } from '../styledComponents/Header.styled';
import LanguageOptions from './LanguageOptions';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';
import Cookies from 'js-cookie';
import {
  helpscoutURL,
  pressHelpscoutId,
  privacyHelpscoutId,
  termsHelpscoutId,
  cookiesHelpscoutId,
  aboutHelpscoutId,
} from '../Variables';
import { checkHost } from './Data';
import { GlobalCtx } from '../context/GlobalContext';

const Footer = () => {
  const [showFooter, setShowFooter] = useState(true);
  const { lang } = useContext(GlobalCtx);
  const { nid } = useParams();
  const date = new Date();
  const year = date.getFullYear();
  const { t } = useTranslation();

  const mediaUrls = () => {
    const langMappings = {
      en: 'CitizenGOUSA',
      'en-af': 'CitizenGOAfrica',
      'en-au': 'citizengooceania',
      'es-ar': 'CitizenGOArgentina',
      'hazteoir': 'HazteOir.org',
      'fr': 'citizengofr',
      'hr': 'CitizenGOhr',
      'it': 'CitizenGOItalia',
      'hu': 'CitizenGOMagyar',
      'pl': 'CitizenGOPolska',
      'fr-ca': 'profile.php?id=61563567602061'
    };
    const fbUrl = `https://www.facebook.com/${
      langMappings[lang.toLowerCase()] || 'citizengo'
    }`;
    return fbUrl;
  };

  const instagramUrls = () => {
    const langMappings = {
      'en-af': 'citizengoafrica/',
      'en-au': 'citizengoaustralia/',
      'en-ca': 'citizengocanada/',
      'es-ar': 'citizengo_argentina/',
      'it': 'citizengo_italia/',
      'pt-br': 'citizengo.brasil/',
      'sk': 'citizengoslovensko/',
    };
    const instagramUrl = `https://www.instagram.com/${
      langMappings[lang.toLowerCase()] || 'citizengo'
    }`;
    return instagramUrl;
  };

  // if pathname includes /lang/share it's LP. Footer shouldn't be render
  useEffect(() => {
    let id = window.location.pathname.split('/');
    id = id.reverse()[0].split('-')[0];
    const URL_PATHNAME = window.location.pathname;
    if (
      URL_PATHNAME.includes('/LP2-share') ||
      URL_PATHNAME.includes('/LP3-donate') ||
      URL_PATHNAME.includes('/contact') ||
      URL_PATHNAME.includes('/privacy')
    ) {
      return setShowFooter(false);
    } else return setShowFooter(true);
  }, []);

  return (
    <>
      {showFooter && (
        <FooterContainer lang={lang}>
          <section>
            <div className="footer-links">
              <div>
                <span>{t('footer.company')}</span>
                <ul>
                  <li>
                    <a
                      href={`${helpscoutURL}/article/${aboutHelpscoutId(
                        lang
                      )}-about`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('footer.about_us')}
                    </a>
                  </li>
                  {["de", "de-at", "de-ch"].includes(lang) && (
                    <li>
                    <a
                      href="https://docs.google.com/document/d/1EVPrZ_y96feStHJZWdT2EuxV8x3__YSDmDapLNdWKQA"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Impressum
                    </a>
                  </li>
                  )}
                  <li>
                    <a href={`${checkHost(`create-petition/${lang}`, lang, 'my-cgo')}`}>
                      {t('header.create_a_petition')}
                    </a>
                  </li>
                  <li>
                    <a href="https://citizengo.bamboohr.com/careers" rel="noreferrer" target="_blank">
                      {t('footer.careers')}
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <span>{t('footer.community')}</span>
                <ul>
                  <li>
                    <a
                      href={
                        lang === 'hazteoir'
                          ? `${pressHelpscoutId()}`
                          : `${helpscoutURL}/article/${pressHelpscoutId()}-press`
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('footer.press')}
                    </a>
                  </li>
                  <li>
                    <a href={`${checkHost('login', lang, 'accounts', nid ? nid.split('-')[0] : '')}`}>
                      {t('footer.login')}
                    </a>
                  </li>
                  <li>
                    <a href={`${checkHost('signup', lang, 'accounts')}`}>
                      {t('footer.register')}
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <span>{t('footer.support')}</span>
                <ul>
                  <li>
                    <a
                      href={t('footer.helpscout_link')}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('footer.contact')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${helpscoutURL}/article/${privacyHelpscoutId()}-privacy`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('footer.privacy')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${helpscoutURL}/article/${termsHelpscoutId()}-terms`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('footer.terms')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${helpscoutURL}/article/${cookiesHelpscoutId()}-cookies`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('footer.cookies')}
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <span>{t('footer.connect')}</span>
                <ul>
                  <li>
                    <a
                      href={`https://twitter.com/${
                        lang === 'hazteoir' ? 'hazteoir' : 'citizengo'
                      }`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a href={`${mediaUrls()}`} target="_blank" rel="noreferrer">
                      Facebook
                    </a>
                  </li>
                  {lang !== 'hazteoir' && (
                    <>
                      <li>
                        <a
                          href="https://www.youtube.com/@CitizenGO"
                          target="_blank"
                          rel="noreferrer"
                        >
                          YouTube
                        </a>
                      </li>
                      <li>
                        <a target="_blank" rel="noreferrer" href={instagramUrls()}>Instagram</a>
                      </li>
                    </>
                  )}

                  {lang === 'hazteoir' && (
                    <>
                      <li>
                        <a
                          href="https://www.instagram.com/hazteoir"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Instagram
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://t.me/HazteOirorg"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Telegram
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/hazteoir"
                          target="_blank"
                          rel="noreferrer"
                        >
                          YouTube
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://whatsapp.com/channel/0029Va8bA0M4NVikiUUJM83d"
                          target="_blank"
                          rel="noreferrer"
                        >
                          WhatsApp
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </div>
          </section>
          <section className="copy">
          <LanguageSelectorStyled
            name="language selector footer"
              onChange={(e) => {
                i18next.changeLanguage(e.target.value, () => {
                  window.location.pathname = i18next.resolvedLanguage;
                });
              }}
              value={Cookies.get('i18next') || 'en'}
            >
              <LanguageOptions />
            </LanguageSelectorStyled>
            <p>&#169; {year} CitizenGO</p>
          </section>
        </FooterContainer>
      )}
    </>
  );
};

export default Footer;
